// TRE-2122: every backend read goes to its own address, so no service worker cache - including an
// older worker still controlling this tab after a deploy - and no browser HTTP cache can answer it
// with a copy it stored earlier, possibly for another account signed in on the same computer.
//
// The marker must differ between tabs and between attempts: a clock or a per-page counter alone can
// repeat in two tabs opened in the same millisecond, so it carries 64 random bits.
//
// No imports: the service-worker browser test loads this file directly as a module.

const FRESH_READ_PARAMETER = "fresh";
let freshReadCount = 0;

function randomSegment() {
  const cryptoApi = typeof crypto !== "undefined" ? crypto : undefined;
  if (cryptoApi && typeof cryptoApi.getRandomValues === "function") {
    const values = cryptoApi.getRandomValues(new Uint32Array(2));
    return values[0].toString(36) + values[1].toString(36);
  }
  return Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
}

export function createFreshReadMarker() {
  freshReadCount += 1;
  return Date.now().toString(36) + freshReadCount.toString(36) + randomSegment();
}

/**
 * Returns the URL with a new `fresh=` marker: an existing marker's value is replaced, otherwise one
 * is appended before any fragment.
 */
export function withFreshReadMarker(url) {
  if (typeof url !== "string" || !url) {
    return url;
  }
  const marker = createFreshReadMarker();
  const existingMarker = new RegExp("([?&]" + FRESH_READ_PARAMETER + "=)[^&#]*");
  if (existingMarker.test(url)) {
    return url.replace(existingMarker, function (_match, prefix) {
      return prefix + marker;
    });
  }
  const hashIndex = url.indexOf("#");
  const base = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? "" : url.slice(hashIndex);
  return base + (base.indexOf("?") === -1 ? "?" : "&") + FRESH_READ_PARAMETER + "=" + marker + hash;
}
